import React from 'react';
import { useDispatch } from 'react-redux';
import {
	DismissButton,
	ModalResetButtonsContainer,
	ModalResetContent,
	ModalResetText,
	ResetButton
} from '../../styles/Modal/Modal';
import { STRINGS } from '../../../constants';
import DelayedButton from '../Common/DelayedButton';
import { deliveriesActions } from '../../../state/ducks/deliveries';

const ModalSyncWithAbas = ({
	handleDismiss,
	showModal
}) => {
	const dispatch = useDispatch();

	const handleSyncClicked = () => {
		dispatch(deliveriesActions.resetInvoiceAbasSync());
		handleDismiss();
	};

	return (
		<ModalResetContent show={showModal}>
			<ModalResetText dangerouslySetInnerHTML={{
				__html: STRINGS.ABAS_SYNC_MSG
			}}/>
			<ModalResetButtonsContainer>
				<DelayedButton onClick={handleSyncClicked} component={ResetButton}>
					{STRINGS.SYNC}
				</DelayedButton>
				<DelayedButton onClick={handleDismiss} component={DismissButton}>
					{STRINGS.REJECT}
				</DelayedButton>
			</ModalResetButtonsContainer>
		</ModalResetContent>
	);
};

export default ModalSyncWithAbas;
